import { Component, OnInit, ViewChild } from '@angular/core';
import { ModalNavigationComponent } from '../../../services/gui/modal/modal-navigation-component';
import { MediumFullDTO, SharedPlaylistDTO } from '../../../services/api/api';
import { ModalNavigationService } from '../../../services/gui/modal/modal-navigation.service';
import { UtilService } from '../../../services/util.service';
import { BehaviorSubject } from 'rxjs';
import { SbMediumComponent } from '../../medium/sb-medium.component';

@Component({
  selector: 'app-sb-playlist-preview',
  templateUrl: './sb-playlist-preview.component.html',
  styleUrls: ['./sb-playlist-preview.component.scss'],
  standalone: false,
})
export class SbPlaylistPreviewComponent implements OnInit, ModalNavigationComponent {
  @ViewChild('videoElement') videoElement: HTMLVideoElement;
  @ViewChild('mediumComponent') mediumComponent: SbMediumComponent;

  playlist: SharedPlaylistDTO;
  isInModalContext: boolean;
  hover: boolean;
  media: MediumFullDTO[];
  playPause: boolean;
  preview: MediumFullDTO;
  currentIndex: number;
  bPreview: BehaviorSubject<MediumFullDTO>;
  timer: NodeJS.Timeout;
  muted: boolean;

  constructor(
    public modal: ModalNavigationService,
    public util: UtilService
  ) {
    this.currentIndex = -1;
    this.preview = undefined;
    this.hover = false;
    this.playPause = true;
    this.media = [];
    this.bPreview = null;
    this.muted = true;
    this.timer = undefined;
  }

  ngOnInit(): void {
    if (!this.isInModalContext) {
      return;
    }
    this.playlist = this.modal.getCurrentNavigation().data.playlist;

    if (this.playlist?.playlist?.iterations?.length > 0) {
      this.buildMediaArray();
      if (this.media.length > 0) {
        this.preview = this.media[0];
        this.currentIndex = 0;
        this.bPreview = new BehaviorSubject<MediumFullDTO>(this.preview);
      }
    }
    if (this.bPreview) {
      this.bPreview.subscribe(() => {
        this.updatePreview();
      });
    }
  }

  buildMediaArray() {
    const mediaMap: Map<number, MediumFullDTO> = new Map<number, MediumFullDTO>();
    for (const booking of this.playlist.playlist.staticBookings) {
      mediaMap.set(booking.id, booking.medium);
    }
    for (const iteration of this.playlist.playlist.iterations) {
      const slots = iteration.slots;
      for (const slot of slots) {
        let medium: MediumFullDTO = null;
        if (slot?.staticBooking?.id) {
          medium = mediaMap.get(slot.staticBooking.id);
        }
        if (medium) {
          this.media.push(medium);
        }
      }
    }
  }

  updatePreview() {
    // take duration or set default to 10s
    const defaultTime = this.media[this.currentIndex]?.duration ? this.media[this.currentIndex]?.duration * 1000 : 10000;
    if (this.timer) {
      clearTimeout(this.timer);
    }
    this.timer = setTimeout(() => {
      if (this.playPause) {
        this.nextMedium();
      }
    }, defaultTime);
  }

  togglePlayPause() {
    this.playPause = !this.playPause;
  }

  toggleMute() {
    this.muted = !this.muted;
  }

  nextMedium() {
    if (this.currentIndex < this.media.length - 1) {
      this.currentIndex++;
    } else {
      this.currentIndex = 0;
    }
    this.preview = this.media[this.currentIndex];
    this.bPreview.next(this.preview);
  }

  lastMedium() {
    if (this.currentIndex > 0) {
      this.currentIndex--;
    } else {
      this.currentIndex = this.media.length - 1;
    }
    this.preview = this.media[this.currentIndex];
    this.bPreview.next(this.preview);
  }

  cancel() {
    this.modal.result(null);
  }
}
